import React, { useContext, useState, useCallback, useEffect } from 'react';

import localize from '../../i18n/localize';
import callBackend from '../../utils/callBackend';
import LocalizedContext from '../../i18n/LocalizedContext';

import '../../styles/colors.css';

import Content from '../../components/Content';
import UserFocus from './UserFocus';
import UserRegistration from './UserRegistration';

const TournamentAdvisor = props => {
    const language = props.language;

    const lang = useContext(LocalizedContext);

    const [registerationStatus, setRegistrationStatus] = useState('unknown');
    const [focus, setFocus] = useState([]);

    const loadFocus = useCallback( () => {
        callBackend('focus', {}, result => {
            if( result.isOk ) {
                setFocus(result.data.focused);
                setRegistrationStatus(result.data.userFound ? 'registered' : 'notRegistered');
            }
        });
    }, []);

    useEffect(() => {
        loadFocus();
    }, [loadFocus] );

    // const tabs = [
    //     {
    //         id: USER_FOCUS_TAB,
    //         name: localize(lang, 'opponent'),
    //         component: <UserFocus focus={focus} />
    //     },
    //     {
    //         id: ADVISORY_TAB,
    //         name: localize(lang, 'advisory'),
    //         component: <PoolAdvisor />
    //     },
    //     {
    //         id: PERFORMANCE_ANALYSIS_TAB,
    //         name: localize(lang, 'performanceAnalysis'),
    //         component: <PerformanceAnalysis />
    //     }
    // ];

    const advisor = (() => {
        switch (registerationStatus) {
            case 'registered':
                return (
                    <UserFocus focus={focus} />
                    // <Tab 
                    //     tabs={tabs}
                    //     defaultTab={USER_FOCUS_TAB}
                    // />
                );
            case 'notRegistered':
                return (
                    <Content 
                        header={localize(lang, 'tournamentAdvisor')}
                        description={localize(lang, 'tournamentAdvisorDescription')}
                    >
                        <UserRegistration language={language} />
                    </Content>
                );
            default:
                return '';
        }
    })();

    return advisor;
}

export default TournamentAdvisor;